import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ReportComponent } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseQueryOptions<unknown, Error, ReportComponent[]>,
    'queryKey' | 'queryFn'
  >;
}

export const useCombinedReportComponentListRequest = ({
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, ReportComponent[]>(
    [Entities.CombinedReportComponent],
    async () => {
      const { data } = await api.v1AdminReportsCombinedReportsComponentsGet()
      return data
    },
    options,
  )
}
